import React from 'react';
import ToDoList from './components/ToDoList/ToDoList';

function App() {
  return (
    <>
      <ToDoList></ToDoList>
    </>
  );
}

export default App;
